import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: 900,
  margin: "40px auto",
  padding: "0 16px",

  [theme.down("md")]: {
    maxWidth: 700,
  },

  [theme.down("sm")]: {
    maxWidth: "100%",
  },
}));

export const Title = styled("h1")(({ theme }) => ({
  fontSize: 28,
  fontWeight: 700,
  marginBottom: 24,
  color: theme.palette.text?.primary,
}));

export const Section = styled("div")(({ theme }) => ({
  marginBottom: 24,
}));

export const SectionTitle = styled("h2")(({ theme }) => ({
  fontSize: 18,
  fontWeight: 600,
  marginBottom: 12,
  color: theme.palette.text?.primary,
}));

export const Content = styled("p")(({ theme }) => ({
  fontSize: 15,
  lineHeight: "24px",
  marginBottom: 10,
  color: theme.palette.text?.secondary,
}));
